import { render, staticRenderFns } from "./orderCreate2.vue?vue&type=template&id=04d785c0&scoped=true"
import script from "./orderCreate2.vue?vue&type=script&lang=js"
export * from "./orderCreate2.vue?vue&type=script&lang=js"
import style0 from "./orderCreate2.vue?vue&type=style&index=0&id=04d785c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d785c0",
  null
  
)

export default component.exports